import { useQuery } from '@tanstack/react-query';

import { staffApi } from '../api/staff';

export const useGetAdminUsers = (
  params: Partial<{
    page: number;
    text: string;
    roleId: number;
    limit?: number;
  }>
) => {
  return useQuery({
    queryKey: ['adminUsers', params],
    queryFn: () => staffApi.getAdminUsers(params),
  });
};
